import { Actions } from '@src/constants/Constants';
import PRELOADER_IS_VISIBLE = Actions.PRELOADER_IS_VISIBLE;

export interface IPreloaderState {
    isVisible: boolean;
}

const initialState: IPreloaderState = {
    isVisible: false,
};

export default function preloaderState(
    state: IPreloaderState = initialState,
    action: any,
): IPreloaderState {
    switch (action.type) {
        case PRELOADER_IS_VISIBLE:
            return { ...state, isVisible: action.payload };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/PreloaderReducer.ts